import React, { useState, useEffect, useRef } from 'react'
import { Button } from 'syngenta-react-components'
import clear from '../../assets/icons/clear.svg'
import Select from '../../dpe-usco/components/Select/Select'
import { getUserRoles, inviteUserWithOkta } from '../../services/apiHelper'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'

const NewAdminForm = ({ handleCancel }) => {
  const [email, setEmail] = useState('')
  const [roleId, setRoleId] = useState('')
  const [roleOptions, setRoleOptions] = useState([])
  const [rolesData, setRolesData] = useState([])
  const [submissionState, setSubmissionState] = useState(null)
  const [errorMsg, setErrorMsg] = useState('')

  const canceled = useRef(false)
  useEffect(() => {
    return () => {
      canceled.current = true
    }
  }, [])

  useEffect(() => {
    getUserRoles().then(roles => {
      if (roles && !canceled.current) {
        const adminRoles = roles.filter(r => r.role_type === 'admin')
        setRolesData(adminRoles)
        setRoleOptions(adminRoles.map(r => r.role_name))
      }
    })
  }, [])

  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  const isFormValid = isValidEmail && roleId !== ''

  const handleRoleSelection = value => {
    const matched = rolesData.find(r => r.role_name === value)
    setRoleId(matched ? matched.role_id : '')
    setErrorMsg('')
  }

  const handleSubmit = async () => {
    setErrorMsg('')

    const domain = email.trim().split('@')[1]?.toLowerCase()
    if (domain !== 'syngenta.com') {
      setErrorMsg(
        'Only Syngenta internal users can be invited. Please use a @syngenta.com email address.'
      )
      return
    }

    setSubmissionState('LOADING')
    try {
      await inviteUserWithOkta({ email: email.trim().toLowerCase(), role_id: roleId })
      if (!canceled.current) {
        setSubmissionState('SUCCESS')
      }
    } catch (err) {
      if (!canceled.current) {
        const msg =
          err?.response?.data?.errors?.[0]?.message ||
          'Failed to invite user. Please try again.'
        setErrorMsg(msg)
        setSubmissionState(null)
      }
    }
  }

  const handleClose = () => {
    setEmail('')
    setRoleId('')
    setErrorMsg('')
    setSubmissionState(null)
    handleCancel()
  }

  if (submissionState === 'LOADING') {
    return (
      <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
        <div className='df jcsb'>
          <p className='fz16 ml16 fw600'>Invite User</p>
          <button className='bdnone m0 bgc-t' onClick={handleClose}>
            <img src={clear} alt='cancel button' />
          </button>
        </div>
        <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
        <div className='p16'>
          <TableStatus status='LOADING' />
        </div>
      </div>
    )
  }

  if (submissionState === 'SUCCESS') {
    return (
      <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
        <div className='df jcsb'>
          <p className='fz16 ml16 fw600'>Invite User</p>
          <button className='bdnone m0 bgc-t' onClick={handleClose}>
            <img src={clear} alt='cancel button' />
          </button>
        </div>
        <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
        <div className='p16 tac'>
          <p>User invited successfully.</p>
        </div>
        <hr className='mt20 mb16 bdnone bt1-s-lightgray' />
        <div className='df jcfe'>
          <Button
            type='success'
            text='Close'
            clickHandler={handleClose}
            customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'
          />
        </div>
      </div>
    )
  }

  return (
    <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
      <div className='df jcsb'>
        <p className='fz16 ml16 fw600'>Invite User</p>
        <button className='bdnone m0 bgc-t' onClick={handleClose}>
          <img src={clear} alt='cancel button' />
        </button>
      </div>
      <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
      <div className='p16 df fxdrc'>
        <div className='mb16'>
          <label className='fz13 db mb4'>Email*</label>
          <input
            type='email'
            placeholder='user@syngenta.com'
            value={email}
            onChange={e => {
              setEmail(e.target.value)
              setErrorMsg('')
            }}
            className='w100%'
            autoComplete='off'
          />
        </div>
        <div className='mb16'>
          <label className='fz13 db mb4'>Role*</label>
          <Select
            placeholder='Select role'
            handleSelection={handleRoleSelection}
            options={roleOptions}
          />
        </div>
        {errorMsg && (
          <p className='c-red fz13 mt0'>{errorMsg}</p>
        )}
      </div>
      <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
      <div className='df jcfe'>
        <Button
          text='Cancel'
          customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'
          clickHandler={handleClose}
        />
        <Button
          type='success'
          text='Invite User'
          clickHandler={handleSubmit}
          disabled={!isFormValid}
          customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'
        />
      </div>
    </div>
  )
}

export default NewAdminForm
